import { makeStyles } from "@material-ui/styles";

const newPeriodDialogStyles = makeStyles(() => ({
	dialogContent: {
		minWidth: 300
	},
	receivingTeamBox: {
		display: "flex",
		alignItems: "center",
		flexDirection: "column"
	}
}));

export default newPeriodDialogStyles;
